<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'SUCURSAL'}]">
      </app-breadcrumb>
    </div>

    <app-top-widgets/>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-search-box">
                  <label><i class="material-icons search-icon">search</i></label>
                  <input
                    #filter
                    aria-autocomplete="none"
                    aria-label="Search box"
                    autocomplete="nope"
                    class="browser-default search-field"
                    placeholder="BUSCAR"
                    type="text">
                </li>
              </ul>
            </div>

            <div class="right">
              <ul class="tbl-export-btn">
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="CREAR">
                    <button (click)="addNew()" color="primary" mat-mini-fab data-tour="branch-btn-add">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </li>

                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="RECARGAR">
                    <button (click)="refresh()" color="primary" mat-mini-fab>
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </div>
                </li>

                <li>
                  <div class="export-button m-l-10" matTooltip="EXCEL">
                    <img (click)="exportExcel()" alt="" src="assets/images/icons/xlsx.png"/>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="body overflow-auto">
            <div class="responsive_table">
              <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

                <ng-container matColumnDef="idSucursal">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.idSucursal}}"></mat-cell>
                </ng-container>

                <ng-container matColumnDef="nombre">
                  <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>NOMBRE</mat-header-cell>
                  <mat-cell
                    *matCellDef="let row"
                    matTooltip="{{row.nombre}}"
                    (click)="goToProfile(row)">
                    <span class="mobile-label">Nombre:</span>
                    <div class="block">
                      <span class="prop_one">{{ row.nombre }}</span>
                      <span class="prop_two" *ngIf="!isParticular">{{ row.registroSanitario }}</span>
                      <span class="status-badge" *ngIf="!isParticular" [ngClass]="{
                        'activo': row.status?.toLowerCase() === 'activo',
                        'inactivo': row.status?.toLowerCase() === 'inactivo',
                        'pendiente': row.status?.toLowerCase() === 'pendiente'
                      }">
                        {{ row.status?.toUpperCase() }}
                      </span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="direccion">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>DIRECCION</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.calle}}">
                    <span class="mobile-label">Direccion:</span>
                    <div class="block">
                      <span class="prop_three">{{ row.calle1 }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="responsable">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>RESPONSABLE</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.responsable}}">
                    <span class="mobile-label">Responsable:</span>
                    <div class="block">
                      <span class="prop_three">{{ row.responsable }}</span>
                      <span class="prop_two">CEDULA: {{ row.cedulaResponsable }}</span>
                      <span class="prop_two">TELEFONO: {{ row.telefonoResponsable }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="correo">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>CORREO</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.emailResponsable}}">
                    <span class="mobile-label">Correo:</span>
                    <a href="mailto:{{row.emailResponsable}}">{{ row.emailResponsable }}</a>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <mat-header-cell *matHeaderCellDef class="pr-0">ACCIONES</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index;" class="pr-0">
                    <button
                      (click)="$event.stopPropagation(); editCall(row)"
                      class="tbl-action-btn"
                      mat-icon-button>
                      <app-feather-icons [class]="'tbl-fav-edit'" [icon]="'edit'"></app-feather-icons>
                    </button>

                    <button
                      *ngIf="row.status?.toLowerCase() !== 'activo' && isAdmin"
                      (click)="$event.stopPropagation(); activateBranch(row)"
                      class="tbl-fav-activate"
                      mat-icon-button
                      matTooltip="ACTIVAR SUCURSAL">
                      <app-feather-icons [class]="'tbl-fav-activate'" [icon]="'check-circle'"></app-feather-icons>
                    </button>

                    <button
                      (click)="$event.stopPropagation(); deleteItem(row)"
                      class="tbl-action-btn"
                      mat-icon-button
                      *ngIf="isAdmin && row.status?.toLowerCase() == 'activo'">
                      <app-feather-icons [class]="'tbl-fav-delete'" [icon]="'trash-2'"></app-feather-icons>
                    </button>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
              </table>

              @if (data.isTblLoading) {
                <div class="tbl-spinner">
                  <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                  </mat-progress-spinner>
                </div>
              }

              @if (!data.isTblLoading) {
                <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
                  SIN RESULTADOS
                </div>
              }

              <mat-paginator
                [length]="dataSource.filteredData.length"
                [pageIndex]="0"
                [pageSizeOptions]="[5, 10, 25, 100]"
                [pageSize]="10">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
